<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'pageBody',
    data () {
      return {
        
      }
    },
    methods: {
      
    }
  }
</script>
<style type="text/css" media="screen">
  
</style>



// WEBPACK FOOTER //
// PageBody.vue?2e1bcd16